export const Menu = [
    { title: "About Us", link: "/about-us" },
    { title: "Services", link: "/services" },
    { title: "Projects", link: "/projects" },
    { title: "Careers", link: "/careers" },
]